/**
 * Ticket AD8: Hinweisseite, kein eigener Bereich. Keine Datenabfrage, keine
 * Schaltflächen – nur ein Wegweiser, damit der Menüpunkt nicht ins Leere zeigt.
 *
 * Entsteht hier der echte Bereich, muss die Kennzeichnung `muted: true` am
 * Eintrag „faq" in src/lib/admin-nav.ts entfernt werden, sonst bleibt eine
 * funktionierende Seite dauerhaft zurückgenommen dargestellt.
 */
import { createFileRoute } from "@tanstack/react-router";
import { AdminPageHeader } from "@/components/admin/AdminPageHeader";

export const Route = createFileRoute("/_admin/admin/faq")({
  component: AdminFaqPlaceholder,
});

function AdminFaqPlaceholder() {
  return (
    <div className="space-y-6">
      <AdminPageHeader
        title="FAQ"
        description="Künftig lassen sich die Fragen und Antworten der Cockpit-Hilfe hier anlegen, umsortieren und in Gruppen ordnen."
      />
      <p className="max-w-2xl text-sm text-muted-foreground">
        Die Cockpit-Hilfe umfasst derzeit 21 Fragen in fünf Gruppen. Sie werden über die Agentur
        gepflegt: Änderungen und neue Fragen geben Sie bitte dort auf, sie werden anschließend
        eingetragen. Wie die Hilfe für Ihre Kundinnen und Kunden aussieht, sehen Sie im Cockpit
        unter „Hilfe &amp; FAQ".
      </p>
    </div>
  );
}
